var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 280,
    height: 280,
    viewBox: "0 0 280 280",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14_2391)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140 280C217.32 280 280 217.32 280 140C280 62.6801 217.32 0 140 0C62.6801 0 0 62.6801 0 140C0 217.32 62.6801 280 140 280Z",
    fill: "#FFAD38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140 264.615C208.823 264.615 264.615 208.823 264.615 140C264.615 71.1768 208.823 15.3846 140 15.3846C71.1768 15.3846 15.3846 71.1768 15.3846 140C15.3846 208.823 71.1768 264.615 140 264.615Z",
    fill: "#FFC066"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.3792 87.769C49.5321 87.769 48.6735 87.536 47.9052 87.0466C45.7543 85.6777 45.121 82.8252 46.4904 80.6749C66.9966 48.4624 101.953 29.231 140 29.231C178.047 29.231 213.003 48.4618 233.51 80.6744C234.879 82.8247 234.245 85.6772 232.095 87.046C229.945 88.4159 227.093 87.7816 225.723 85.6313C206.921 56.0945 174.874 38.4617 140 38.4617C105.126 38.4617 73.0795 56.0956 54.2768 85.6313C53.3974 87.0132 51.9045 87.769 50.3792 87.769Z",
    fill: "#FD9A0C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.891 70.7694H109.936C107.387 70.7694 105.32 72.8361 105.32 75.385C105.32 77.934 107.387 80.0007 109.936 80.0007H125.045L118.891 70.7694Z",
    fill: "#CA7B0A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.064 70.7694H161.109L154.955 80.0001H170.064C172.613 80.0001 174.68 77.9335 174.68 75.3845C174.68 72.8355 172.613 70.7694 170.064 70.7694Z",
    fill: "#CA7B0A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.987 83.1545C182.053 83.1545 173.189 92.0194 173.189 102.953H161.109V70.7689H154.247C150.166 70.7689 146.858 74.077 146.858 78.1583V102.953H140H133.143V78.1583C133.143 74.077 129.835 70.7689 125.754 70.7689H118.892V102.953H106.812C106.812 92.0188 97.9475 83.1545 87.0138 83.1545C76.0802 83.1545 67.2153 92.0194 67.2153 102.953V178.278C88.3017 178.278 105.547 161.831 106.823 141.066C106.823 141.063 107.878 141.06 107.878 141.058H118.417C118.417 150.806 124.135 159.129 132.197 162.455L114.739 197.714C114.739 197.714 125.233 202.461 140.001 202.461C154.769 202.461 165.263 197.714 165.263 197.714L147.805 162.455C155.867 159.129 161.586 150.805 161.586 141.058H172.123C172.123 141.061 173.179 141.064 173.179 141.066C174.455 161.832 191.699 178.278 212.786 178.278V102.953C212.786 92.0188 203.922 83.1545 192.987 83.1545Z",
    fill: "#FD9A0C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.923 248.513H123.077C120.528 248.513 118.461 246.446 118.461 243.897C118.461 241.348 120.528 239.281 123.077 239.281H156.923C159.472 239.281 161.539 241.348 161.539 243.897C161.539 246.446 159.472 248.513 156.923 248.513Z",
    fill: "#FD9A0C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.846 227.795H106.154C103.605 227.795 101.538 225.729 101.538 223.18C101.538 220.631 103.605 218.564 106.154 218.564H173.846C176.395 218.564 178.462 220.631 178.462 223.18C178.462 225.729 176.395 227.795 173.846 227.795Z",
    fill: "#FD9A0C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14_2391"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 280,
    height: 280,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoin);
export default __webpack_public_path__ + "static/media/coin.ac2615b29d9e19b207e8f937e563bbae.svg";
export { ForwardRef as ReactComponent };